@let storico = purchase.storico ?? [];

<ng-template #sale let-item>
    <div class="purchase-card">
        <div class="purchase-row">
            <span class="body-medium">{{ 'products.ui.qtaVenduta' | transloco }}</span>
            <span class="body-medium emphasized">{{ item.quantita ?? 0 }} {{ 'products.ui.pz' | transloco }}</span>
        </div>
        <div class="purchase-row">
            <span class="body-medium">{{ 'products.ui.prezzo' | transloco }}</span>
            <span class="body-medium emphasized">
                {{ item.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } : 'EUR' }}@if (unit) {/{{ unit }}}
            </span>
        </div>
    </div>
</ng-template>

<div class="purchase-history">
    <div class="purchase-header">
        <span class="body-small purchase-date">{{ purchase.data | date: 'dd/MM/yyyy' }}</span>
        <button matButton type="button" (click)="onApply()">{{ 'products.ui.applica' | transloco }}</button>
    </div>
    <ng-container *ngTemplateOutlet="sale; context: { $implicit: purchase }" />

    @if (storico.length > 0) {
        <button type="button" class="history-toggle title-small emphasized" [attr.aria-expanded]="historyOpen()" (click)="toggleHistory()">
            {{ 'products.ui.storico' | transloco }}
            <i class="fa-regular" [class.fa-chevron-up]="historyOpen()" [class.fa-chevron-down]="!historyOpen()"></i>
        </button>

        @if (historyOpen()) {
            @for (item of storico; track $index) {
                <span class="body-small purchase-date">{{ item.data | date: 'dd/MM/yyyy' }}</span>
                <ng-container *ngTemplateOutlet="sale; context: { $implicit: item }" />
            }
        }
    }

    @if (applied()) {
        <div class="purchase-applied body-medium">{{ 'products.ui.prezzoEQuantitaUltimaVenditaApplicati' | transloco }}</div>
    }
</div>
